import e from "../managers/braze-instance.js";
import { logger as r } from "../../shared-lib/index.js";
export function destroy() {
  r.info("Destroying Braze instance"), e.destroy(!0);
}
